module.exports = __webpack_public_path__ + "img/rule11.png";